import { render, staticRenderFns } from "./FaqRibbonIcon.vue?vue&type=template&id=7d0890d8"
import script from "./FaqRibbonIcon.vue?vue&type=script&lang=js"
export * from "./FaqRibbonIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports